import * as CryptoJS from 'crypto-js';

export function getEncrypt(encryptStr: string, options: any) {
  return CryptoJS.AES.encrypt(encryptStr, CryptoJS.enc.Utf8.parse(options.encryptKey), {
    iv: CryptoJS.enc.Utf8.parse(options.encryptIv),
  }).toString();
}
